<template>
	<div class="info">
		<h3>Оплата заказа банковской картой:</h3>

		<p>Для выбора оплаты с помощью банковской карты необходимо зайти на страницу "Бегущая строка", перейти в раздел
		"Подать объявление в бегущую строку" нажать кнопку «Оплатить». Оплата происходит через ООО НКО «ЮМани» с
		использованием Банковских карт следующих платежных систем:</p>

		<p>МИР</p>

		<p>VISAInternational</p>

		<p>Mastercard Worldwide</p>

		<h3>Возврат денежных средств</h3>

		<p>Оплата услуги возвращается только в случае своевременного аннулирования заказа. Своевременное аннулирование
		заказа – не позднее, чем за один рабочий день до даты запланированного выхода объявления в бегущую строку.</p>

		<h3>Описание процесса передачи данных</h3>

		<p>Для оплаты покупки Вы будете перенаправлены на платежный шлюз ООО НКО «ЮМани» для ввода реквизитов Вашей
		карты. Пожалуйста, приготовьте Вашу пластиковую карту заранее. Соединение с платежным шлюзом и передача
		информации осуществляется в защищенном режиме с использованием протокола шифрования SSL.</p>

		<p>В случае если Ваш банк поддерживает технологию безопасного проведения интернет-платежей Verified By Visa или
		MasterCard Secure Code для проведения платежа также может потребоваться ввод специального пароля. Способы и
		возможность получения паролей для совершения интернет-платежей Вы можете уточнить в банке, выпустившем карту.</p>

		<p>Настоящий сайт поддерживает 128-битное шифрование. Конфиденциальность сообщаемой персональной информации
		обеспечивается ООО НКО «ЮМани». Введенная информация не будет предоставлена третьим лицам за исключением
		случаев, предусмотренных законодательством РФ. Проведение платежей по банковским картам осуществляется в строгом
		соответствии с требованиями платежных систем Visa Int. и MasterCard Europe Sprl.</p>

		<h3>Юридическая информация</h3>
		<p>Общество с ограниченной ответственностью «Вещательная корпорация «ТЕЛЕСФЕРА» <br>
		Юридический адрес: 660028, Российская Федерация, г. Красноярск, ул. Баумана, д. 22 <br>
		Фактический адрес: 660028, Российская Федерация, г. Красноярск, ул. Баумана, д. 22 <br>
		ИНН: 2463011765 / КПП: 246301001 <br>
		ОГРН: 1022402128880</p>

	</div>
</template>

<script>
	export default {
		name: "TheTerms"
	}
</script>

<style scoped>

</style>
